import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "d-flex flex-column gap-5 align-items-center w-100 p-3" }
const _hoisted_2 = {
  style: {"height":"200px","background-color":"#056331"},
  class: "mx-5 w-100 d-flex align-items-center justify-content-center rounded-3"
}
const _hoisted_3 = { class: "text-white" }
const _hoisted_4 = { class: "mx-5 d-flex flex-column gap-4 list-unstyled" }
const _hoisted_5 = { class: "item-home" }
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "item-home" }
const _hoisted_8 = {
  href: "https://www.clubdebeneficios.com",
  class: "text-decoration-none text-secondary d-flex flex-column gap-4",
  target: "_blank"
}
const _hoisted_9 = ["src"]
const _hoisted_10 = { class: "item-home" }
const _hoisted_11 = {
  href: "https://m365.cloud.microsoft/apps/",
  class: "text-decoration-none text-secondary d-flex flex-column gap-4",
  target: "_blank"
}
const _hoisted_12 = ["src"]
const _hoisted_13 = { class: "item-home" }
const _hoisted_14 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h1", _hoisted_3, _toDisplayString(_ctx.$t('beneficios')), 1)
    ]),
    _createElementVNode("ul", _hoisted_4, [
      _createElementVNode("li", _hoisted_5, [
        _createElementVNode("img", {
          src: $setup.getFlyer(3),
          alt: "Menu Semanal",
          class: "img-fluid rounded-4"
        }, null, 8, _hoisted_6)
      ]),
      _createElementVNode("li", _hoisted_7, [
        _createElementVNode("a", _hoisted_8, [
          _createElementVNode("img", {
            src: $setup.getFlyer(1),
            alt: "Beneficios",
            class: "img-fluid rounded-4"
          }, null, 8, _hoisted_9)
        ])
      ]),
      _createElementVNode("li", _hoisted_10, [
        _createElementVNode("a", _hoisted_11, [
          _createElementVNode("img", {
            src: $setup.getFlyer(2),
            alt: "Medien Archiv",
            class: "img-fluid rounded-4"
          }, null, 8, _hoisted_12)
        ])
      ]),
      _createElementVNode("li", _hoisted_13, [
        _createElementVNode("img", {
          src: $setup.getFlyer(4),
          alt: "Menu Semanal",
          class: "img-fluid rounded-4 w-100"
        }, null, 8, _hoisted_14)
      ])
    ]),
    _cache[0] || (_cache[0] = _createElementVNode("br", null, null, -1))
  ]))
}